/**
 * @param {String} key       message key used to find the configured translation.
 * @param {String} fallback  fallback translation in the event that the configured translation could not be resolved.
 * @return {String}
 */
export function translate(key, fallback = "") {
  if (window.translations) {
    return window.translations[key] || fallback;
  }

  return fallback;
}

/**
 * @param {String} key       message key used to find the configured translation.
 * @param {Array}  args      arguments to substitute in the translation. For e.g. if the translation text has {0} then the first argument in the array will be substituted in place of that
 * @param {String} fallback  fallback translation in the event that the configured translation could not be resolved.
 * @return {String}
 */
export function translateArgs(key, args = [], fallback = "") {
  let translationWithArgs;
  if (window.translations) {
    translationWithArgs = window.translations[key];
  }

  if (!translationWithArgs) {
    translationWithArgs = fallback;
  }

  for (let i = 0; i < args.length; i++) {
    const lookup = new RegExp(`\\{${i}\\}`, "g");
    translationWithArgs = translationWithArgs.replace(lookup, args[i]);
  }

  return translationWithArgs;
}